import { Row, Card } from 'react-bootstrap';
import { uniqueId } from 'lodash';
import '../styles/components/accordion-card.scss';

const AccordionCard = ({ title, parent, children }) => {
  let headerId = uniqueId('cardHeader-');
  let divId = uniqueId('collapsingDiv-');

  return (
    <Row className="accordion-row accordion-item">
      <Card className="accordion-card">
        <Card.Header
          id={headerId}
          className="accordion-header accordion-button collapsed"
          role="button"
          data-bs-toggle="collapse"
          data-bs-target={`#${divId}`}
          aria-expanded="false"
          aria-controls={`${divId}`}
        >
          <h2>{title}</h2>
        </Card.Header>

        <div
          id={divId}
          className="accordion-collapse collapse"
          aria-labelledby={`${headerId}`}
          data-bs-parent={`#${parent}`}
        >
          <Card.Body className="accordion-body">{children}</Card.Body>
        </div>
      </Card>
    </Row>
  );
};

export default AccordionCard;
